var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import crossFetch from 'cross-fetch';
var fetch = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return crossFetch.apply(void 0, __spread(args)).then(function (res) {
        if (res.ok) {
            return res;
        }
        else {
            // TODO: Refactor error handling for fetch. Currently it return an instance of the Error object
            // For this reason, we can compare only error message. We should return define clear interface
            // for error handlin.
            var error = new Error(res.statusText);
            error.response = res;
            return Promise.reject(error);
        }
    });
};
export default fetch;
